export default "__VITE_PUBLIC_ASSET__757341fb__"